import type { Dispatch } from "redux";
import actions from "~/shared/actions";
import * as server from "~/shared/api/server";

export function loadNorskPensjon(data: server.NorskPensjonRequest) {
	return async (dispatch: Dispatch) => {
		dispatch(actions.norskPensjonRequest(data));
		const res = await server.getNorskPensjon(data);
		dispatch(actions.norskPensjonResponse(res));
		return res;
	};
}

export function resetNorskPensjon() {
	return (dispatch: Dispatch) => dispatch(actions.resetNorskPensjon());
}

export function setExtraSavings(extraSavings) {
	return (dispatch: Dispatch) => dispatch(actions.setExtraSavings(extraSavings));
}

export function loadNorskPensjonPkbs() {
	return (dispatch: Dispatch) => {
		dispatch(actions.norskPensjonPkbsRequest());
		return server.getNorskPensjonPkbs().then((result) => dispatch(actions.norskPensjonPkbsResponse(result)));
	};
}
